module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [(_vm.boxedit) ? _c('div', {
    ref: "boxedit",
    staticClass: "intro-y box mt-6"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateUser.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.user.name
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('name', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Apodo:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.user.nickname
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('nickname', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Correo:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email",
      "required": ""
    },
    domProps: {
      "value": _vm.user.email
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('email', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Contraseña (opcional):")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.user.password
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('password', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3"
  }, [_c('label', [_vm._v("Equipo")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.user.team_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('team_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el equipo")]), _vm._v(" "), _vm._l((_vm.teams), function(team) {
    return _c('option', {
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n                " + _vm._s(team.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3"
  }, [_c('label', [_vm._v("Perfil")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.user.profile_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('profile_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el equipo")]), _vm._v(" "), _vm._l((_vm.profiles), function(profile) {
    return _c('option', {
      domProps: {
        "value": profile.id
      }
    }, [_vm._v("\n                " + _vm._s(profile.name) + " - " + _vm._s(profile.team.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Role")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.user.roles[0].id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('role', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el role")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Administrativo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Lider")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Coordinador")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Trabajador")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.user.active
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('active', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inactivo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Activo")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("ID Compañia")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "integer",
      "required": ""
    },
    domProps: {
      "value": _vm.user.id_company
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('id_company', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 sm:col-span-2"
  }, [_c('label', [_vm._v("Cumpleaños")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": _vm.user.birthday
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('birthday', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-4"
  }, [_c('label', [_vm._v("Bono Cumpleaños")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.user.prize
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('prize', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 sm:col-span-2"
  }, [_c('label', [_vm._v("Fecha Ingreso")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.user.admission_date
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('admission_date', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3"
  }, [_c('label', [_vm._v("Foto")]), _vm._v(" "), _c('EditPhoto', {
    attrs: {
      "user": _vm.user
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Url foto PNG")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.user.img_png
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('img_png', $event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeEditUser()
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "update"
    }
  }, [_vm._v("\n            Modificar\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-3 sm:flex-row items-center"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2"
  }, [_vm._v("\n        Usuarios (" + _vm._s(_vm.filteredUsers.length) + ")\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('app-icon', {
    attrs: {
      "name": 'search',
      "classname": 'w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700'
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.name),
      expression: "filter.name"
    }],
    staticClass: "input w-full sm:w-64 box px-10 text-gray-700",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por nombre"
    },
    domProps: {
      "value": (_vm.filter.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "name", $event.target.value)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter dropdown absolute inset-y-0 mr-3 right-0 flex items-center"
  }, [_c('app-icon', {
    attrs: {
      "name": "chevron-down",
      "classname": "dropdown-toggle w-4 h-4 cursor-pointer text-gray-700"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20"
  }, [_c('div', {
    staticClass: "dropdown-box__content box p-5"
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Equipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.team),
      expression: "filter.team"
    }],
    staticClass: "input w-full border mt-2 flex-13",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "team", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione una opción")]), _vm._v(" "), _vm._l((_vm.teams), function(team) {
    return _c('option', {
      key: team.id,
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n                      " + _vm._s(team.name) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('button', {
    staticClass: "button mt-28 text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": function($event) {
        _vm.filter = _vm.clearFilter()
      }
    }
  }, [_vm._v("\n                      Borrar Filtro\n                    ")])])])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex mr-2"
  }, [_c('button', {
    staticClass: "button text-white bg-theme-1 zoom-in",
    on: {
      "click": _vm.downloadList
    }
  }, [_vm._v("\n          Descargar\n        ")]), _vm._v(" "), _c('a', {
    ref: "download_users",
    staticClass: "hidden",
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer nofollow"
    }
  }, [_vm._v("Descargar")])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (_vm.users_incomplete.length) ? _c('div', {
    staticClass: "p-4 bg-white mt-5 rounded"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.users_incomplete), function(item) {
    return _c('p', [_vm._v("\n          - " + _vm._s(item.name) + " (" + _vm._s(item.email) + ")\n        ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "intro-y flex grid grid-cols-12 gap-6 mt-5"
  }, _vm._l((_vm.filteredUsers), function(user) {
    return _c('div', {
      key: user.id,
      staticClass: "intro-y col-span-12 md:col-span-6"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "flex flex-col lg:flex-row items-center p-5 border-b border-gray-200"
    }, [_c('div', {
      staticClass: "w-24 h-24 lg:w-12 lg:h-12 image-fit lg:mr-1"
    }, [(user.avatar) ? _c('img', {
      staticClass: "rounded-full",
      attrs: {
        "alt": "Profile",
        "src": user.avatar
      }
    }) : _c('img', {
      staticClass: "rounded-full",
      attrs: {
        "alt": "Profile",
        "src": "/static/images/profile.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "font-medium",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(user.name) + " (" + _vm._s(user.roles[0].name) + ")")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v("\n                " + _vm._s(user.team ? user.team.name : '-') + " :\n                " + _vm._s(user.profile ? user.profile.name : '-') + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "flex -ml-2 lg:ml-0 lg:justify-end mt-3 lg:mt-0"
    }, [(user.active === 0) ? _c('a', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in",
      attrs: {
        "title": "Estado"
      },
      on: {
        "click": function($event) {
          return _vm.editUser(user)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'alert-triangle',
        "classname": 'w-4 h-4 mr-2'
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "pl-2 w-12 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in",
      class: {
        'back-red': !user.accounts.length
      },
      attrs: {
        "to": ("/admin/account-user/" + (user.id))
      }
    }, [_vm._v("\n                " + _vm._s(user.accounts.length) + "\n                "), _c('app-icon', {
      attrs: {
        "name": "folder",
        "classname": "w-4 h-4 ml-1 mr-2"
      }
    })], 1), _vm._v(" "), _c('router-link', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in",
      attrs: {
        "to": '/admin/calendar/' + user.slug
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'calendar',
        "classname": 'w-4 h-4 mr-2'
      }
    })], 1), _vm._v(" "), _c('a', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in",
      on: {
        "click": function($event) {
          return _vm.editUser(user)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'edit',
        "classname": 'w-4 h-4 mr-2'
      }
    })], 1), _vm._v(" "), _c('a', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in",
      on: {
        "click": function($event) {
          return _vm.removeUser(user)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'trash',
        "classname": 'w-4 h-4 mr-2'
      }
    })], 1)], 1)])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "user"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--md"
  }, [_vm._m(3), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createUser.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Contraseña:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Correo:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Equipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.team_id),
      expression: "user.team_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "team_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el equipo")]), _vm._v(" "), _vm._l((_vm.teams), function(team) {
    return _c('option', {
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n                  " + _vm._s(team.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Perfil")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile_id),
      expression: "user.profile_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "profile_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el perfil")]), _vm._v(" "), _vm._l((_vm.filteredProfiles), function(profile) {
    return _c('option', {
      domProps: {
        "value": profile.id
      }
    }, [_vm._v("\n                  " + _vm._s(profile.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Role")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.role),
      expression: "user.role"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el role")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "business"
    }
  }, [_vm._v("Administrativo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "leader"
    }
  }, [_vm._v("Lider")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "coordinator"
    }
  }, [_vm._v("Coordinador")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "employee"
    }
  }, [_vm._v("Trabajador")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("ID Compañia")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.id_company),
      expression: "user.id_company"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "integer",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.id_company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "id_company", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(4)])])])]) : _c('div', [_c('app-loading')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Editar Usuario")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#user",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Usuario")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb-2"
  }, [_vm._v("Los siguientes usuarios no tienen la informacion completa: "), _c('b', [_vm._v("(Apodo, Cumpleaños, fecha ingreso)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Crear Usuario")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              Cancelar\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("\n              Crear\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-527534be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/user/ListUser.vue
// module id = 438
// module chunks = 1